'use strict'
require('core-js/modules/es.array.includes')
require('core-js/modules/es.array.index-of')
require('core-js/modules/es.object.keys')
exports.__esModule = true
exports.getNativeType = getNativeType
exports.toPrivateName = toPrivateName
exports.getItem = getItem
exports.setItem = setItem
exports.removeItem = removeItem

var _is = require('../is')
var _json = require('../json')

var DEFAULT_STORAGE_TYPE = 'localStorage'
var nativeTypes = ['localStorage', 'sessionStorage']
var PRIVATE_NAME_PREFIX = '__ar__'

function getNativeType(maybeType) {
  return (0, _is.isStr)(maybeType) && nativeTypes.includes(maybeType) ? maybeType : DEFAULT_STORAGE_TYPE
}

function toPrivateName(name) {
  return name.indexOf(PRIVATE_NAME_PREFIX) === 0 ? name : PRIVATE_NAME_PREFIX + name
}

// const PRIVATE_NAME_PREFIX_REGEX = /^__ar__/
// export function fromPrivateName( name: string ) {
//   return name.replace( PRIVATE_NAME_PREFIX_REGEX, '' )
// }

function getItem(name, type) {
  var result = {
    isValid: false,
    value: null,
    isStorageHasItem: false,
    isEmpty: true
  }

  var storage = window[getNativeType(type)]
  var item = storage.getItem(toPrivateName(name))

  if ((0, _is.isNull)(item)) return result

  result.isStorageHasItem = true

  var parsedItem = (0, _json.parseObj)(item)

  if ((0, _is.isNull)(parsedItem)) return result

  return {
    isValid: true,
    value: parsedItem,
    isStorageHasItem: true,
    isEmpty: Object.keys(parsedItem).length === 0
  }
}

function setItem(name, value, type) {
  var storage = window[getNativeType(type)]
  var val = (0, _is.isStr)(value) ? value : (0, _json.str)(value)
  if (val === null) return false

  storage.setItem(toPrivateName(name), val)

  return true
}

function removeItem(name, type) {
  var storage = window[getNativeType(type)]
  storage.removeItem(toPrivateName(name))
  return true
}



//////////////////
// WEBPACK FOOTER
// ./~/hlp/dist/Storages/funcs.js
// module id = 308
// module chunks = 0